import React from "react";
import Navigation from "../components/Navigation";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Biography from "../components/Biography";
import Gallery from "../components/Gallery";
import Music from "../components/Music";
import MediaShowcase from "../components/MediaShowcase";
import TourHighlights from "../components/TourHighlights";
import BookingForm from "../components/BookingForm";
import Footer from "../components/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="bg-[#0A0A0A] text-[#F5F5F5]">
      <Navigation />
      <Hero />
      <Marquee />
      <Biography />
      <Gallery />
      <Music />
      <MediaShowcase />
      <TourHighlights />
      <BookingForm />
      <Footer />
    </main>
  );
}
